import { reduceToArray } from '../../../../utils/reduce-to-array';
import { getSiteById } from './get-site-by-id';
export const getSitesByIds = (siteIds) => reduceToArray(siteIds, getSiteById);
//# sourceMappingURL=get-sites-by-ids.js.map